// extracted by mini-css-extract-plugin
module.exports = {"suggestion-item":"Suggestion_suggestion-item__Y3r2L","icon-container":"Suggestion_icon-container___ozwo"};